var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { atom } from 'jotai';
import { v4 as uuid } from 'uuid';
import { InkyApiV2 } from '../API/InkyApiV2';
import AddToCartOverlay from '../Models/AddToCartOverlay';
import { selectAtom } from 'jotai/utils';
//region UI-atoms
export var ShowCartAtom = atom(false);
//endregion
//region Fetch Cart
export var CartAtom = atom(false);
export var CartHasItemsAtom = selectAtom(CartAtom, function (cart) { var _a, _b; return cart && ((_b = (_a = cart.cartItems) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0; });
export var FetchCartAtom = atom(function (get) { return get(CartAtom); }, function (get, set) { return __awaiter(void 0, void 0, void 0, function () {
    var cart;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, InkyApiV2.shared().FetchCart()];
            case 1:
                cart = _a.sent();
                set(CartAtom, cart);
                return [2 /*return*/];
        }
    });
}); });
//endregion
export var RegionLockedAtom = atom(false);
export var AddToCartOverlayAtom = atom(false);
export var GetAddToCartOverlayBox = atom(function (get) {
    return get(AddToCartOverlayAtom);
}, function (get, set, obj) {
    set(AddToCartOverlayAtom, obj.show);
    set(RegionLockedAtom, obj.regionLocked);
});
export var UpdatingCartAtom = atom(false);
//region AddProductToCart
export var AddToCartAction = atom(function (get) { return get(CartAtom); }, function (get, set, product) { return __awaiter(void 0, void 0, void 0, function () {
    var updatedCart, overlay, overlay;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, , 2, 3]);
                set(UpdatingCartAtom, true);
                return [4 /*yield*/, InkyApiV2.shared().AddProductToCart(product.productId, product.variantId)];
            case 1:
                updatedCart = _a.sent();
                if (updatedCart !== null) {
                    overlay = new AddToCartOverlay();
                    overlay.show = true;
                    overlay.regionLocked = false;
                    set(GetAddToCartOverlayBox, overlay);
                    set(CartAtom, updatedCart);
                }
                else if (updatedCart === null) {
                    overlay = new AddToCartOverlay();
                    overlay.show = true;
                    overlay.regionLocked = true;
                    set(GetAddToCartOverlayBox, overlay);
                }
                return [3 /*break*/, 3];
            case 2:
                set(UpdatingCartAtom, false);
                return [7 /*endfinally*/];
            case 3: return [2 /*return*/];
        }
    });
}); });
//endregion
//region DeductProductFromCart
export var DeductFromCartAction = atom(function (get) { return get(CartAtom); }, function (get, set, product) { return __awaiter(void 0, void 0, void 0, function () {
    var updatedCart;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, , 2, 3]);
                set(UpdatingCartAtom, true);
                return [4 /*yield*/, InkyApiV2.shared().DeductProductFromCart(product.productId, product.variantId)];
            case 1:
                updatedCart = _a.sent();
                console.log("Deducting Product from cart", product);
                set(CartAtom, updatedCart);
                return [3 /*break*/, 3];
            case 2:
                set(UpdatingCartAtom, false);
                return [7 /*endfinally*/];
            case 3: return [2 /*return*/];
        }
    });
}); });
//endregion
//region RemoveAllOfProductFromCart
export var RemoveAllOfProductFromCartAction = atom(function (get) { return get(CartAtom); }, function (get, set, product) { return __awaiter(void 0, void 0, void 0, function () {
    var updatedCart;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, InkyApiV2.shared().RemoveAllOfProductFromCart(product.productId, product.variantId)];
            case 1:
                updatedCart = _a.sent();
                console.log("Removing all of Product from cart", product);
                set(CartAtom, updatedCart);
                return [2 /*return*/];
        }
    });
}); });
//endregion
//region CartId
var PersistentCartIdKey = "CartId";
export var PersistentCartIdAtom = atom(false);
export var CartIdAtom = atom(function (get) { return get(PersistentCartIdAtom); }, function (get, set, cartId) {
    console.log("[CartID] Setting CartId to " + cartId);
    localStorage.setItem(PersistentCartIdKey, cartId);
    // Set the Api before anything else, since other atoms may trigger API-calls
    InkyApiV2.shared().CartId = cartId;
    // Set other atoms.
    set(PersistentCartIdAtom, cartId);
    set(FetchCartAtom);
});
CartIdAtom.onMount = function (set) {
    console.log("[CartID] Initiated.");
    // Set the CartID to be the stored value, if that does not exist, create a new one.
    set(localStorage.getItem(PersistentCartIdKey) || uuid());
};
//endregion
//region ClearCart
export var ClearCartAction = atom(function (get) { return get(CartAtom); }, function (get, set) { return __awaiter(void 0, void 0, void 0, function () {
    var updatedCart;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, InkyApiV2.shared().ClearCart()];
            case 1:
                updatedCart = _a.sent();
                console.log("Cleared cart");
                set(CartAtom, updatedCart);
                return [2 /*return*/];
        }
    });
}); });
export var AbandonCart = atom(function (get) { return get(CartAtom); }, function (get, set) {
    console.log("Abandoning old cart, creating new cart.");
    set(CartIdAtom, uuid());
});
//endregion
